import { Box, Button, CircularProgress } from "@mui/material";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import RefreshIcon from "@mui/icons-material/Refresh";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

interface CacheActionsProps {
  isWarming: boolean;
  isBusy: boolean;
  onWarm: () => void;
  onRefresh: () => void;
  onPurgeAll: () => void;
}

const CacheActions = ({
  isWarming,
  isBusy,
  onWarm,
  onRefresh,
  onPurgeAll,
}: CacheActionsProps) => (
  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
    <Button
      variant="contained"
      startIcon={
        isWarming ? (
          <CircularProgress size={18} color="inherit" />
        ) : (
          <LocalFireDepartmentIcon />
        )
      }
      onClick={onWarm}
      disabled={isBusy}
    >
      {isWarming ? "Warming…" : "Warm cache"}
    </Button>
    <Button
      variant="outlined"
      startIcon={<RefreshIcon />}
      onClick={onRefresh}
      disabled={isBusy}
    >
      Refresh
    </Button>
    <Button
      variant="outlined"
      color="error"
      startIcon={<DeleteForeverIcon />}
      onClick={onPurgeAll}
      disabled={isBusy}
      sx={{ ml: { sm: "auto" } }}
    >
      Purge all
    </Button>
  </Box>
);

export default CacheActions;
